// Auto-generated by scripts/generateFactionSkinConfig.mjs
// Do not edit manually.

// eslint-disable-next-line no-unused-vars
import {FACTIONS} from '../../../constants/factions';
// eslint-disable-next-line no-unused-vars
import {PLAYER_COLORS} from '../../colors';

export const FACTION_SKINS_TECHNODWARVES = [{
  id: 'technodwarves_engineer',
  factionId: FACTIONS.TECHNODWARVES,
  name: 'Техножрец',
  priceNumens: 16000,
  skinRank: 1,
}, {
  id: 'technodwarves_miner',
  factionId: FACTIONS.TECHNODWARVES,
  name: 'Глубинный бурильщик',
  priceNumens: 58000,
  skinRank: 2,
  colors: [
    PLAYER_COLORS.YELLOW,
    PLAYER_COLORS.ORANGE,
    PLAYER_COLORS.SKY_BLUE
  ]
}, {
  id: 'technodwarves_juggernaut',
  factionId: FACTIONS.TECHNODWARVES,
  name: 'Джаггернаут',
  priceNumens: 100000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.CELADON,
  ]
}, {
  id: 'technodwarves_gold_legacy',
  factionId: FACTIONS.TECHNODWARVES,
  name: 'Рунный молотобоец',
  priceNumens: 120000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.YELLOW,
  ],
  excludedFromChests: true
}, {
  id: 'technodwarves_ruby_legacy',
  factionId: FACTIONS.TECHNODWARVES,
  name: 'Громовержец',
  priceCrystals: 350,
  skinRank: 4,
  colors: [
    PLAYER_COLORS.YELLOW,
    PLAYER_COLORS.RED,
  ],
  accentColor: PLAYER_COLORS.RED,
  excludedFromChests: true
}];
